import { createSelector } from 'reselect';
import { DEAL_PROPERTIES } from '../constants/CrmSearchConstants';
export const getPropertiesState = state => {
  return state.properties;
};
export const getProperties = createSelector([getPropertiesState], propertiesState => {
  return propertiesState === null || propertiesState === void 0 ? void 0 : propertiesState.properties;
});
export const getForecastCategoryProperty = createSelector([getProperties], properties => {
  return properties === null || properties === void 0 ? void 0 : properties[DEAL_PROPERTIES.FORECAST_CATEGORY];
});
export const getPropertiesStatus = createSelector([getPropertiesState], propertiesState => {
  return propertiesState === null || propertiesState === void 0 ? void 0 : propertiesState.propertiesStatus;
});
export const getPropertyGroups = createSelector([getPropertiesState], propertiesState => {
  return propertiesState === null || propertiesState === void 0 ? void 0 : propertiesState.propertyGroups;
});
export const getPropertyGroupsStatus = createSelector([getPropertiesState], propertiesState => {
  return propertiesState === null || propertiesState === void 0 ? void 0 : propertiesState.propertyGroupsStatus;
});